
export const SITE_INSPECTION_STATUS = {
    PotentialIncident: 'Potential Incident',
    SiteVisitPending: 'Site Visit Pending',
    SiteVisitScheduled: 'Site Visit Scheduled',
    SiteVisitScheduledNoAccessRequired: 'Site Visit Scheduled No Access Required',
    AccessRequiredLetterSent: 'Access Required Letter Sent',
    IncidentNoLetterSent: 'Incident - No Letter Sent',
    IncidentInitialLetterSent: 'Incident - Initial Letter Sent',
    IncidentSecondLetterSent: 'Incident - Second Letter Sent',
    IncidentFinalLetterSent: 'Incident - Final Letter Sent',
    ContractorRequired: 'Contractor Required',
    ContractorAssigned: 'Contractor Assigned',
    WorksCompleted: 'Works Completed',
    Closed: 'Closed',
    CustomerEngagedContractor: 'Customer Engaged Contractor'
};

export const SITE_INSPECTION_STATUS_ID = {
    WorksCompleted: 'WorksCompleted',
    Closed: 'Closed',
};

export const ROLES = {
    // OLD ROLES
    Employee: 'Employee',
    Customer: 'Customer',

    Contractor: 'Contractor',
    Admin: 'Admin',
    SiteVegetationInspector: 'SiteVegetationInspector',
    VegetationAdmin: 'VegetationAdmin',
    CallCentreStaff: 'CallCentreStaff',
    VegetationReadonlyUser: 'VegetationReadonlyUser',
    RoleForTestingPurposesOnly: 'RoleForTestingPurposesOnly',

    ENAACreator: 'ENAACreator',
    ENAASwitchers: 'ENAASwitchers',
    ENAAReadOnly: 'ENAAReadOnly'
};

export const PERMISSIONS = {
    GenerateNotificationBatch: "GenerateNotificationBatch",
    UpdateStatusBatch: "UpdateStatusBatch",
    ScheduleSiteInspectionBulk: "ScheduleSiteInspectionBulk",
    GenerateNotification: "GenerateNotification",
    SearchSiteInspections: "SearchSiteInspections",
    SearchSiteInspectionsContractorAssigned: "SearchSiteInspectionsContractorAssigned",
    SearchSiteInspectionsDone: "SearchSiteInspectionsDone",
    SearchSiteInspectionsLetter: "SearchSiteInspectionsLetter",
    SearchSiteInspectionsContractor: "SearchSiteInspectionsContractor",
    SearchSiteInspectionsOpen: "SearchSiteInspectionsOpen",
    SearchSiteInspectionsNotificationDueDate: "SearchSiteInspectionsNotificationDueDate",
    SearchSites: "SearchSites",
    AddSiteInspection: "AddSiteInspection",
    ViewSiteInspection: "ViewSiteInspection",   
    ChangeNotificationDueDate: "ChangeNotificationDueDate",
    CloseSiteInspection: "CloseSiteInspection",
    CloseSiteInpsectionCustomerCleared: "CloseSiteInpsectionCustomerCleared",
    CloseSiteInpsectionContractorCleared: "CloseSiteInpsectionContractorCleared",
    CloseSiteInpsectionCreatedInError: "CloseSiteInpsectionCreatedInError",
    EditSiteInspectionPostalAddress: "EditSiteInspectionPostalAddress",
    EditSiteInspectionOwnership: "EditSiteInspectionOwnership",
    ChangeSiteInspectionStatus: "ChangeSiteInspectionStatus",
    AddSiteVisit: "AddSiteVisit",
    CopySiteVisit: "CopySiteVisit",
    AddNote: "AddNote",
    EditDefectPriority: "EditDefectPriority",
    ResolveInspectionDefect: "ResolveInspectionDefect",
    AddUser: "AddUser",
    DeleteUser: "DeleteUser",
    EditUser: "EditUser",
    ViewJobs: "ViewJobs",
    EditSite: "EditSite",
    ClientConfiguration: "ClientConfiguration",
    ChangeInspectionNumber: "ChangeInspectionNumber",
    AddSiteInspectionReview: "AddSiteInspectionReview",
    ViewSiteInspectionReview: "ViewSiteInspectionReview",
    UpdateSiteInspectionReview: "UpdateSiteInspectionReview",
    ViewForms: "ViewForms",
    CreateForm: "CreateForm",
    AddCommentsToForms: "AddCommentsToForms",
    TickForms: "TickForms"
};

export const SITE_INSPECTION_RESULT = {
    Pending: 'Pending',
    NoIncident: 'No Incident',
    IncidentClosed: 'Incident Closed',
    InspectedNoIncident: 'Inspected - No Incident',
    WrongAddress: 'Wrong Address',
    CloseSiteInpsectionCreatedInError: 'Close Site Inpsection- Created In Error',
    CustomerClearedNotifiedByCorrespondence: 'Customer Cleared - Notified By Correspondence',
    CloseSiteInpsectionContractorCleared: 'Close Site Inpsection - Contractor Cleared',
};


export const INCIDENT_ITEMS = [
    {
        text: 'Is Tree Close To High Voltage',
        value: 'Is Tree Close To High Voltage',
    },
    {
        text: 'Is Tree Close To Low Voltage',
        value: 'Is Tree Close To Low Voltage',
    },
    {
        text: 'Is Tree Too Close To House Service',
        value: 'Is Tree Too Close To House Service',
    },
    {
        text: "Is Tree Too Close To Neighbour's House",
        value: 'Is Tree Too Close To Neighbour House',
    },
];

export const EDITOR_TOOLS = {
    pointer: 'pointer',
    redCircle: 'redCircle',
    greenCircle: 'greenCircle',
    orangeLine: 'orangeLine',
    blueLine: 'blueLine',
    purpleLine: 'purpleLine'
};

export const INSPECTION_REVIEW = {
    RequiresReview: {
        text:'Requires Review',
        value:'RequiresReview'
    },
    ReviewCompleted:{
        text:'Review Completed',
        value:'ReviewCompleted'
    },
    NoReviewRequired:{
        text:'No Review Required',
        value:'NoReviewRequired'
    }
};
export const DEFECT_PRIORITY = {
    UP1: {value: 'UP1', text: 'UP1'},
    UP2: {value: 'UP2', text: 'UP2'},
    UP3: {value: 'UP3', text: 'UP3'},
    BP1: {value: 'BP1', text: 'BP1'},
    BP2: {value: 'BP2', text: 'BP2'},
    BP3: {value: 'BP3', text: 'BP3'},
    BP4: {value: 'BP4', text: 'BP4'}
};

export const INSPECTION_REVIEW_REASON = {
    DepartmentOfHousingProperty: {
        text: 'Dept. of Housing Property',
        value: 'DepartmentOfHousingProperty'
    },
    VacantBlock: {
        text: 'Vacant Block',
        value: 'VacantBlock'
    },
    BodyCorpComplex: {
        text: 'Body Corp Complex',
        value: 'BodyCorpComplex'
    },
    Other: {
        text: 'Other',
        value: 'Other'
    },
    LockedGate: {
        text: 'Locked Gate',
        value: 'LockedGate'
    },    
    RefusedEntry: {
        text: 'Refused Entry',
        value: 'RefusedEntry'
    },
    DogsInYard: {
        text: 'Dogs in yard',
        value: 'DogsInYard'
    },
    CustomerSubmitted: {
        text: 'Customer Submitted',
        value: 'CustomerSubmitted'
    },
    SubsequentialNoticeRequired: {
      text: 'Subsequential Notice Required',
      value: 'SubsequentialNoticeRequired'
    },
    None: {
        text: 'None',
        value: 'None'
    }
};

export const getEnumValues = (enumType) => {
    var keys = Object.keys(enumType);
    var result = [];
    for(var i=0; i<keys.length; i++)
        result.push(enumType[keys[i]]);
    return result;
};



// WEBPACK FOOTER //
// ./src/models/enums.js